import { z } from 'zod';
import { BOARD_CODES, DIFFICULTIES, LANGUAGES, LEVELS, PRACTICE_ITEM_TYPES, QUESTION_TYPES, SUGGESTION_STATUSES, USER_ROLES, } from './enums.js';
/**
 * Request and response shapes shared by the API and the web app. The API
 * validates with these; the web app derives its types from them, so a route
 * cannot drift from its client.
 */
export const boardCodeSchema = z.enum(BOARD_CODES);
export const userRoleSchema = z.enum(USER_ROLES);
export const levelSchema = z.enum(LEVELS);
export const languageSchema = z.enum(LANGUAGES);
export const questionTypeSchema = z.enum(QUESTION_TYPES);
export const difficultySchema = z.enum(DIFFICULTIES);
export const practiceItemTypeSchema = z.enum(PRACTICE_ITEM_TYPES);
export const suggestionStatusSchema = z.enum(SUGGESTION_STATUSES);
export const uuidSchema = z.string().uuid();
/** Every list endpoint pages the same way. */
export const paginationSchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().optional(),
});
export const subjectSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    code: z.string(),
    position: z.number().int(),
});
export const subTopicSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    position: z.number().int(),
});
export const topicSchema = z.object({
    id: uuidSchema,
    subjectId: uuidSchema,
    name: z.string(),
    position: z.number().int(),
    subTopics: z.array(subTopicSchema),
});
/**
 * What a student sees in a topic list. Unreleased topics come back by name with
 * `released: false` — locked, never hidden (section 9).
 */
export const studentTopicSchema = z.object({
    id: uuidSchema,
    subjectId: uuidSchema,
    name: z.string(),
    position: z.number().int(),
    released: z.boolean(),
    /** Null when the topic is not released to this student's class. */
    level: levelSchema.nullable(),
    /** 0-100 across the topic's sub-topics, or null before any attempt. */
    mastery: z.number().min(0).max(100).nullable(),
    teacherNote: z.string().nullable(),
});
export const errorResponseSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        /** Present only outside production. */
        details: z.unknown().optional(),
    }),
});
//# sourceMappingURL=schemas.js.map